import React from 'react';
import styled from 'styled-components';
import { Typography, Column, Row, GridContainer } from '@vp/react-vp-ui-library';
import { getLocalizedText as t } from '@vp-dst/localization-util';

import checkIcon from '../images/check-16px.svg';

const BulletText = styled(Typography)`
  margin-top: 0px;
`;

const BulletedList = ({ children }: { children: any[] }) => (
  <ul className="icon-bullet-list">
    {children.map((child, index) => (
      <li key={`list-item-${index}`}>
        <img
          className="icon-bullet-list-icon"
          src={checkIcon}
          alt=""
          role="presentation"
          style={{
            width: 16,
            height: 13,
            flex: 'none', // infinite-loop-snowflake: override "flex-grow: 1" to keep the icon the correct size
          }}
        />
        <div className="icon-bullet-list-content">{child}</div>
      </li>
    ))}
  </ul>
);

export default function UploadinformationSubArea() {
  return (
    <GridContainer>
      <Row>
        <Column span={12}>
          <Typography purpose="heading" size={2} style={{ marginTop: 10, marginBottom: 45 }}>
            {t('things-to-keep-in-mind')}
          </Typography>
        </Column>
      </Row>
      <Row>
        <Column span={6}>
          <BulletedList>
            <BulletText>{t('keep-all-important-information')}</BulletText>
            <BulletText>{t('for-best-results')}</BulletText>
          </BulletedList>
        </Column>
        <Column span={6}>
          <BulletedList>
            <BulletText>
              {`${t('recommended-file-types-are')
                .replace(
                  '<recommended-file-formats />',
                  t('comma-separated-list')
                    // todo: thise should be bold
                    .replace('<comma-separated-list-items />', '.pdf, .ai')
                    .replace('<last-list-item />', '.psd'),
                )
                .replace(
                  '<other-file-formats />',
                  t('comma-separated-list')
                    .replace(
                      '<comma-separated-list-items />',
                      '.pic, .pict, .pct, .bmp, .doc, .gif, .jpg, .jpeg, .pcx, .png, .ppt, .ps, .tif',
                    )
                    .replace('<last-list-item />', '.tiff'),
                )}
              `}
            </BulletText>
            <BulletText>
              <span
                dangerouslySetInnerHTML={{
                  // todo: restructure translations to better suppor this use-case
                  __html: t('for-more-help').replace(
                    '<upload-help-anchor />',
                    `<a href="/vp/ns/propath/UploadResources.aspx?selectedTab=1" target="_blank">${t(
                      'upload-help-and-tips',
                    )}</a>`,
                  ),
                }}
              />
            </BulletText>
          </BulletedList>
        </Column>
      </Row>
    </GridContainer>
  );
}
